import dotProp from 'dot-prop'
import React from 'react'

import ObjectField from 'react-jsonschema-form/lib/components/fields/ObjectField'
import { connect } from 'react-redux'

import { actions } from "react-redux-form"

import { getUiOptions } from 'selectors/forms'
import { Button } from "semantic-ui-react";
import SemanticPaginatedSelectorField from "./SemanticPaginatedSelectorField";
import SemanticSelectorField from "./SemanticSelectorField";

class SemanticPolymorphicSelectorField extends ObjectField {
  render() {
    const {
      uiSchema,
      entityType,
      nextType,
      typeOptions
    } = this.props;

    const { "ui:options": options , "ui:placeholder": placeholder}   = uiSchema

    if (!entityType || entityType.length === 0 || !options) return null
    uiSchema["ui:options"] = {...options, ...typeOptions}

    let TypeToggle = (props) => <Button icon={typeOptions.icon} {...props} onClick={(event) => {event.stopPropagation(); event.preventDefault(); this.props.toggle(nextType)}}></Button>

    if (typeOptions.paginated) {
     return( <SemanticPaginatedSelectorField {...this.props} uiSchema={uiSchema} SideButton={TypeToggle}/>)
    }
    return (
      <SemanticSelectorField {...this.props} uiSchema={uiSchema} SideButton={TypeToggle}/>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

 let selectedEntityTypeModel = `${ownProps.model || ''}.${ownProps.name.replace('Id','')}Type`
 let selectedEntityModel = `${ownProps.model || ''}.${ownProps.name}`

  return {
    toggle: (type) => {
      let capType = type.charAt(0).toUpperCase() + type.slice(1)
      dispatch(actions.change(selectedEntityTypeModel, capType))
      dispatch(actions.change(selectedEntityModel, null))
  }
  }
}

const mapStateToProps = (state, ownProps) => {
  var options = getUiOptions(state,ownProps)
  let types = options.types

  let selectedEntityTypeModel = `${ownProps.model || ''}.${ownProps.name.replace('Id','')}Type`
  let selectedEntityType = dotProp.get(state, selectedEntityTypeModel)?.toLowerCase()

  if (!selectedEntityType) {
    selectedEntityType = options.types[0].entityName
  }

  let selectedIndex = types.findIndex(type => type.entityName === selectedEntityType)
  let typeOptions = types[selectedIndex]
  let nextType = types[(selectedIndex + 1)%types.length].entityName

  return {
    typeOptions: typeOptions ,
    entityType: selectedEntityType,
    nextType: nextType,
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(SemanticPolymorphicSelectorField);
